import DocumentSimplifiedDTO from "features/invoices/dtos/DocumentSimplifiedDTO";
import React from "react";
import PageCard from "features/shared/components/card/PageCard";
import DocumentDownload from "./DocumentDownload";
import { useTranslation } from "react-i18next";
import RenderWrapper from "../renderWrapper/RenderWrapper";

type Props = {
  documents: DocumentSimplifiedDTO[];
  title?: string;
  expandToHeight?: boolean;
  className?: string;
};

const DocumentDownloadCard = ({
  documents,
  title,
  expandToHeight,
  className,
}: Props) => {
  // translations
  const tLabels = useTranslation("shared\\components").t;

  // render
  return (
    <PageCard
      title={title ?? tLabels("documentDownloadCard.cardTitle")}
      expandToHeight={expandToHeight}
      cardClassName={className}
    >
      <RenderWrapper
        isVisible={() => documents.length > 0}
        noVisibleRender={() => (
          <>{tLabels("documentDownloadCard.noDocuments")}</>
        )}
      >
        {documents.map((item, index) => (
          <div className="py-1" key={index}>
            <DocumentDownload document={item} />
          </div>
        ))}
      </RenderWrapper>
    </PageCard>
  );
};

export default DocumentDownloadCard;
